import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  ISO_DAYS_OF_WEEK,
  TIME_OF_DAY_KEYS,
  TIME_OF_DAY_LABELS
} from "@outschool/timetable";
import { Checkbox, Space } from "@outschool/ui-legacy-component-library";
import { Screen } from "@outschool/ui-utils";
import _ from "lodash";
import React from "react";

export default function EditableTimetable({
  timetable,
  onChange,
  disabled
}: $TSFixMe) {
  const isMobile = Screen.useIsMobile();
  const allSelected = _.every(timetable, d => _.every(d, _.identity));

  const handleToggle = (day: $TSFixMe, time: $TSFixMe) => {
    const timetableClone = _.cloneDeep(timetable);
    timetableClone[day.toLowerCase()][time] =
      !timetableClone[day.toLowerCase()][time];
    onChange(timetableClone);
  };

  const handleToggleDay = (day: $TSFixMe) => {
    const timetableClone = _.cloneDeep(timetable);
    TIME_OF_DAY_KEYS.forEach(
      time =>
        (timetableClone[day.toLowerCase()][time] =
          !timetableClone[day.toLowerCase()][time])
    );
    onChange(timetableClone);
  };

  const handleToggleTime = (time: $TSFixMe) => {
    const timetableClone = _.cloneDeep(timetable);
    ISO_DAYS_OF_WEEK.forEach(
      day =>
        (timetableClone[day.toLowerCase()][time] =
          !timetableClone[day.toLowerCase()][time])
    );
    onChange(timetableClone);
  };

  const handleToggleAll = () => {
    onChange(
      _.mapValues(timetable, d =>
        _.mapValues(d, () => (allSelected ? false : true))
      )
    );
  };

  return (
    <Box>
      <Checkbox
        id="all"
        label="Select all times"
        onChange={handleToggleAll}
        checked={allSelected}
      />
      <Space y="medium" />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "max-content repeat(3, 1fr)"
            : "max-content repeat(7, 1fr)",
          gridGap: "1em",
          alignItems: "center"
        }}
      >
        <Box />
        {isMobile
          ? TIME_OF_DAY_KEYS.map((time, i) => (
              <AxisLabel key={time} onClick={() => handleToggleTime(time)}>
                {TIME_OF_DAY_LABELS[i]}
              </AxisLabel>
            ))
          : ISO_DAYS_OF_WEEK.map(d => (
              <AxisLabel key={d} onClick={() => handleToggleDay(d)}>
                {d}
              </AxisLabel>
            ))}

        <Separator />

        {isMobile
          ? ISO_DAYS_OF_WEEK.map(day => (
              <React.Fragment key={day}>
                <AxisLabel onClick={() => handleToggleDay(day)}>
                  {day}
                </AxisLabel>
                {TIME_OF_DAY_KEYS.map(time => (
                  <Checkbox
                    id={time + day}
                    key={time + day}
                    checked={timetable[day.toLowerCase()][time]}
                    onChange={() => handleToggle(day, time)}
                    disabled={disabled}
                  />
                ))}
              </React.Fragment>
            ))
          : TIME_OF_DAY_KEYS.map((time, i) => (
              <React.Fragment key={time}>
                <AxisLabel onClick={() => handleToggleTime(time)}>
                  {TIME_OF_DAY_LABELS[i]}
                </AxisLabel>
                {ISO_DAYS_OF_WEEK.map(day => (
                  <Checkbox
                    id={time + day}
                    key={time + day}
                    checked={timetable[day.toLowerCase()][time]}
                    onChange={() => handleToggle(day, time)}
                    disabled={disabled}
                  />
                ))}
                {i < TIME_OF_DAY_KEYS.length - 1 && <Separator />}
              </React.Fragment>
            ))}
      </Box>
    </Box>
  );
}

function Separator() {
  return (
    <Box
      sx={{
        height: "1px",
        backgroundColor: "grey.100",
        gridColumn: "1/-1"
      }}
    />
  );
}

function AxisLabel(props: $TSFixMe) {
  return (
    <Box
      sx={{
        fontSize: "0.875em",
        color: "grey.500",
        cursor: "pointer",

        "&:hover": {
          color: "grey.700"
        },

        userSelect: "none"
      }}
      {...props}
    />
  );
}
